'use strict';
var $ = require('../internals/export');
var setPrototypeOf = require('../internals/object-set-prototype-of');

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.object.set-prototype-of.js
// module id = 1350
// module chunks = 0